import axios from 'axios';

export const getFlavors = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/flavors/detail?sort_key=memory_mb`, settings);
}
